// Shared photo/video choice tile used on the Before and After steps.
// Two of these sit side-by-side — same size, same border treatment, same
// icon + label arrangement — so neither format feels primary. Camera icon
// for the photo path, film-strip icon for the video path.

export function CaptureChoice({
  kind,
  label,
  onClick,
}: {
  kind: 'photo' | 'video';
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="aspect-square rounded-2xl border-2 border-dashed border-line-strong bg-bg-alt grid place-items-center text-ink-700 hover:border-navy-900 dark:hover:border-gold-500 transition-colors"
    >
      <div className="flex flex-col items-center gap-2">
        <div className="w-14 h-14 rounded-full bg-gold-500/15 grid place-items-center text-gold-500">
          {kind === 'photo' ? (
            <CameraIcon className="w-7 h-7" />
          ) : (
            <FilmIcon className="w-7 h-7" />
          )}
        </div>
        <span className="font-display text-base">{label}</span>
      </div>
    </button>
  );
}

function CameraIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
      <circle cx="12" cy="13" r="4" />
    </svg>
  );
}

function FilmIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" />
      <line x1="7" y1="2" x2="7" y2="22" />
      <line x1="17" y1="2" x2="17" y2="22" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <line x1="2" y1="7" x2="7" y2="7" />
      <line x1="2" y1="17" x2="7" y2="17" />
      <line x1="17" y1="17" x2="22" y2="17" />
      <line x1="17" y1="7" x2="22" y2="7" />
    </svg>
  );
}
